export const landingPageEvent = () => {
  window.fbq('track', 'Lead')
}
export const purchase = (currency, value) => {
  window.fbq('track', 'Purchase', { currency, value })
}
